import Tooltip from "react-bootstrap/Tooltip";

export const renderToolImportance = (text) => (
    <Tooltip>
        <span style={{ color: "#c99489" }}>{text}</span>
    </Tooltip>
)